import { render, staticRenderFns } from "./NoteDetails.vue?vue&type=template&id=d9e776c2&"
import script from "./NoteDetails.vue?vue&type=script&lang=js&"
export * from "./NoteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports